<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="!cobrancas || !cobrancas.length">
    Não foram encontrados boletos de cobrança com os filtros informados.
  </div>

  <div *ngIf="cobrancas && cobrancas.length">

    <bn-paginacao [total]="atributosPaginacao.count" [tamanhoPagina]="atributosPaginacao.pageSize"
      [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th *ngIf="!ehAgenteFinanceiro" id="col-age" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'nomeAgenteFinanceiro'"
                  [nomeAtributoExibicao]="'Agente financeiro'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-id" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'id'" [nomeAtributoExibicao]="'ID'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-age" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'codigoCobranca'"
                  [nomeAtributoExibicao]="'Código da cobrança'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-tipo" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'tipoCobranca'"
                  [nomeAtributoExibicao]="'Tipo de cobrança'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-data-emissao" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataEmissaoDaFicha'"
                  [nomeAtributoExibicao]="'Dt. emissão'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-data-vencimento" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataVencimentoDaFicha'"
                  [nomeAtributoExibicao]="'Dt. vencimento'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-data-pagamento" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataPagamentoDaFicha'"
                  [nomeAtributoExibicao]="'Dt. pagamento'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-estado" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'estado.nomeEstado'"
                  [nomeAtributoExibicao]="'Estado'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th scope="col" class="text-center">
                Ações
              </th>
            </tr>


          </thead>
          <tbody>
            <tr *ngFor="let cobranca of cobrancas">
              <td *ngIf="!ehAgenteFinanceiro">{{ cobranca.nomeAgenteFinanceiro }}</td>
              <td>{{ cobranca.id }}</td>
              <td>{{ cobranca.codigoCobranca }}</td>
              <td>{{ obterTipoCobranca(cobranca.tipoCobranca) }}</td>
              <td>{{ cobranca.dataEmissaoDaFicha | date: 'dd/MM/yyyy'}}</td>
              <td>{{ cobranca.dataVencimentoDaFicha | date: 'dd/MM/yyyy'}}</td>
              <td>{{ cobranca.dataPagamentoDaFicha | date: 'dd/MM/yyyy'}}</td>
              <td>{{ cobranca.estado?.nomeEstado}}</td>
              <td>
                <a [routerLink]="['/cobrancas', cobranca.id]">
                  <i class="fa fa-search" aria-hidden="true" placement="left-top" ngbTooltip="Visualizar detalhes">&nbsp;&nbsp;</i>
                </a>
                <a href="javascript:void(0)" (click)="exportarBoleto(cobranca)"><i class="fa fa-download" ngbTooltip="Baixar boleto em PDF"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>